module.exports = __webpack_public_path__ + "2e0a26891320c3cd44ca2134c46dcf49.pdf";